<template>
    <v-banner :style="{ backgroundImage: `url(${image})`}" elevation="10" icon="Vuetify" class="banner1">
        <v-row>
            <v-col cols="12" lg="12" class="d-flex justify-center">
                <p style="font-size: 3.5rem; " class="d-flex justify-center">
                    <b>{{ title }}</b>
                </p>
            </v-col>
        </v-row>
    </v-banner>
</template>
<script>
    export default {
        name: "SectionTitle",
        props: {
            title: {
                type: String,
                required: true
            },
            image: {
                type: String,
                required: true
            }
        }
    };
</script>
<style scoped>
    .banner1 {
        /* background-image: url(../assets/banner5.jpg); */
        background-image: url(../assets/banner4.jpg);
        background-size: cover;
        background-position: center;
        height: 170px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: white;
        font-size: 2rem;
        margin-left: -20%; 
        margin-right: -20%;
    }
</style>